module.exports = false;



//////////////////
// WEBPACK FOOTER
// C:/Users/strahinja.aparac/Desktop/git/source/healthcare/v2/app/appointment-widget/node_modules/core-js/modules/_library.js
// module id = ../../../../core-js/modules/_library.js
// module chunks = polyfills